import React from 'react';
import MaskedInput from 'react-maskedinput';


export default function CustomMaskedInput(props) {
  const [localValue, changeLocalValue] = React.useState(props.value);
  const { placeholder, onChange, setError, errorRef, tabIndex } = props;

  React.useEffect(() => {
    changeLocalValue(props.value);
  }, [props.value]);

  const isValidDatefun = (date) => {
    const d = new Date(date);
    let [month, day, year] = date.split('/');

    // need to reduce month value by 1 to accommodate new Date formats the month as month index start from 0
    --month;
    if (d.getFullYear() == year && d.getMonth() == month && d.getDate() == day) {
      return true;
    }
    return false;
  };

  const onValueChange = (date) => {
    const formattedValue = date;
    if (formattedValue && formattedValue.trim().length === 10) {
      const isValidDate = isValidDatefun(formattedValue);

      changeLocalValue(formattedValue);
      if (!isValidDate) {
        setError(errorRef, false, "Invalid date");
      } else {
        onChange(formattedValue);
        setError(errorRef, true);
      }
    } else {
      changeLocalValue(formattedValue);
      setError(errorRef, true);
    }
  };


  return (
    <MaskedInput
      mask="11/11/1111"
      placeholder={placeholder}
      value={localValue}
      onChange={(e) => onValueChange(e.target.value)}
      tabIndex={tabIndex || 1}
    />
  );
}
